export const breakpoints = {
  values: {
    mobile: 0,
    largeMobile: 500,
    tablet: 640,
    mediumTablet: 750,
    largeTablet: 900,
    laptop: 1024,
    desktop: 1200,
    mediumDesktop: 1300,
    largeDesktop: 1400,
    muviFixedContainer: 1784, // 1664 figma max width + 120 mui horizontal padding (left and right)
    extraLargeDesktop: 1900,
  },
};
